import { render, staticRenderFns } from "./ModalBackofficeGerarCobranca.vue?vue&type=template&id=64e3cb0a&scoped=true"
import script from "./ModalBackofficeGerarCobranca.vue?vue&type=script&lang=ts"
export * from "./ModalBackofficeGerarCobranca.vue?vue&type=script&lang=ts"
import style0 from "./ModalBackofficeGerarCobranca.vue?vue&type=style&index=0&id=64e3cb0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e3cb0a",
  null
  
)

export default component.exports